import React from 'react';
import { Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { AxiosResponse, AxiosError } from 'axios';

import { ProductModel } from '../../../../Models/ProductModel';
import { ClientProductModel, clientProductModelInitial } from '../../../../Models/ClientProductModel';
import ProductService from '../../../../Services/ProductService';
import { EditAction } from '../../../../shared/enum/EditAction';
import { ClientContext } from '../../ClientContext';
import { ClientErrorContext } from '../../ClientErrorContext';
import { AuthContext } from '../../../Authentication/AuthContext';
import { HomeContext } from '../../../Home/HomeContext';

export function ClientProductField() {
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientErrorContext = React.useContext(ClientErrorContext);
    const clientContext = React.useContext(ClientContext);

    const [productList, setProductList] = React.useState<ProductModel[]>([]);

    React.useEffect(() => {
        if (productList.length === 0) {
            ProductService.productService()
                .getAll()
                .then((res: AxiosResponse) => {
                    if (res.data)
                        setProductList(res.data);
                })
                .catch((error: AxiosError) => { homeContext.showError('Ops.. ocorreu um erro ao carregar a lista de produtos da MCW. <br/>', error); });
        }
    }, []);

    const handleAddProduct = (product: ProductModel) => {
        const clientProductList: ClientProductModel[] = [...clientContext.products];
        const existingProductIndex = clientProductList.findIndex(p => p.productId === product.id);

        if (existingProductIndex > -1 && clientProductList[existingProductIndex].editAction == EditAction.DELETE) {
            clientProductList[existingProductIndex].editAction = EditAction.NONE;
        }
        else {
            const newProduct: ClientProductModel = {...clientProductModelInitial};
            newProduct.productId = product.id;
            newProduct.productDescription = product.description;
            newProduct.clientId = clientContext.client.id;
            newProduct.userId = authContext.login.user.id;
            newProduct.editAction = EditAction.INSERT;

            clientProductList.push(newProduct);
        }

        clientContext.setProducts(clientProductList);
    };

    const handleDeleteProduct = (product: ProductModel) => {
        const clientProductList: ClientProductModel[] = [...clientContext.products];
        const productIndex = clientProductList.findIndex(p => p.productId == product.id);

        if (clientProductList[productIndex].editAction != EditAction.INSERT)
            clientProductList[productIndex].editAction = EditAction.DELETE;
        else
            clientProductList.splice(productIndex, 1);

        clientContext.setProducts(clientProductList);
    };

    const handleDeleteAllProducts = () => {
        const clientProductList: ClientProductModel[] = [...clientContext.products];

        const filteredProducts = clientProductList
            .filter((cp: ClientProductModel) => cp.editAction != EditAction.INSERT)
            .map((fcp: ClientProductModel) => {
                fcp.editAction = EditAction.DELETE;
                return fcp;
            });

        clientContext.setProducts(filteredProducts);
    };

    return (
        <Autocomplete
            id="client-products"
            multiple
            filterSelectedOptions
            options={productList}
            getOptionLabel={(option) => option.description}
            value={productList.filter(sp =>
                clientContext.products
                    .filter(cp => cp.editAction != EditAction.DELETE)
                    .some(cp => cp.productId === sp.id))}
            onChange={(_, __, reason, detail) => {
                if (detail && detail.option) {
                    if (reason === 'remove-option')
                        handleDeleteProduct(detail.option);
                    else if (reason === 'select-option')
                        handleAddProduct(detail.option);
                } else if (reason === 'clear') {
                    handleDeleteAllProducts();
                }
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        key={index}
                        variant="outlined"
                        label={option.description}
                        {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Produtos"
                    variant="outlined"
                    error={clientErrorContext.productNotSelectedError &&
                        !(clientContext.products.filter(p => p.editAction != EditAction.DELETE).length > 0)}
                    helperText={clientErrorContext.productNotSelectedError &&
                        !(clientContext.products.filter(p => p.editAction != EditAction.DELETE).length > 0)
                        && 'Campo obrigatório'}
                />
            )}
        />
    );
}